import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Image,
} from "react-bootstrap";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../ContactForm/ContactForm";
import { v4 as uuidv4 } from "uuid"; // Import UUID
import { BASE_URL } from "../../constants";

const BlogsPage = () => {
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const blogs = [
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_7.png",
      title:
        "How AI Is Changing the Way Leaders Make Decisions",
        preview:
    "The true value of AI for leadership is not found in time savings, but in its ability to act as a...",
      intro: (
    <>
  <p>
    <strong>Hypothesis</strong>
    <br />
    The true value of AI for leadership is not found in “stopwatch gains” (saving
    time on manual tasks), but in its ability to serve as a <strong>Decision
    Multiplier</strong>. By integrating end-to-end business context with
    institutional memory, AI allows leaders to move from reactive instinct to proactive, economically sound strategy.
  </p>
  </>
      ),
body: (
    <>
  <p>
    <strong>The Legacy of the “Gut Call”</strong>
    <br />
    Not long ago, most leadership decisions followed a familiar pattern: review
    last quarter’s numbers, talk to a few trusted people, apply experience, and
    make a call.
  </p>

  <p>
    Data mattered, but it arrived late and often raised more questions than
    answers. It was a “rear-view mirror” approach to navigation.
    <br />
    <br />
    Today, organizations have far more data, yet many decisions are still made on
    instinct. Data is consulted at the outset, but rarely revisited.
  </p>

  <p>
    Once a decision is made, few teams look back to test their original
    assumptions against actual outcomes. This lack of a feedback loop means that
    while technology has advanced, the decision-making process has not.
  </p>

  <p>
    <strong>Mapping the Value Chain</strong>
    <br />
    Improving decision quality starts with understanding how the business
    actually works end-to-end. Mapping the value chain makes it clear how
    decisions in one area affect others — pricing, demand, capacity, service
    levels, and financial results.
  </p>

  <p>
    To make that view usable, companies need a shared knowledge base that captures
    institutional memory:
  </p>

  <ul>
    <li>Historical outcomes and lessons learned</li>
    <li>Decision rationales and the “why” behind the choice</li>
    <li>Key assumptions and known constraints</li>
  </ul>

  <p>
    Over time, this becomes institutional memory — something most organizations
    lack. This knowledge base feeds a business control tower: a single view where
    operational, commercial, market, and financial data come together.
  </p>

  <p>
    The control tower does not make decisions. It provides context — showing
    trade-offs, sensitivities, and risks across the entire value chain.
  </p>

  <p>
    <strong>Industry Spotlight: The Biofuel “Control Tower”</strong>
    <br />
    In the biofuel industry — specifically Bioethanol and Sustainable Aviation
    Fuel (SAF) — the complexity of the value chain is a prime candidate for an
    Agentic AI Architecture.
  </p>

  <p>
    Traditional software tracks data in silos. An agentic structure acts as
    connective tissue, orchestrating specialized AI agents to manage trade-offs
    between feedstock volatility, process chemistry, and carbon intensity (CI)
    regulations.
  </p>

  <p>
    Imagine a “Bio-Control Tower” where multiple specialized agents feed into a
    shared institutional knowledge base:
  </p>

  <ol>
    <li>
      <strong>The Feedstock & Market Agent:</strong> Scans global markets for corn
      or residues and cross-references spot prices with logistics constraints.
      Recommendation: Switch to Feedstock B — raw cost is 5% higher, but CI score
      is 12% lower, qualifying for higher tax credits.
    </li>
    <li>
      <strong>The Process & TEA Agent:</strong> Runs continuous techno-economic
      analysis to simulate sensitivity across market prices, regulatory changes,
      and energy costs. Recommendation: Adjust conversion parameters to prioritize
      low-CI output today.
    </li>
    <li>
      <strong>The CI & Regulatory Agent:</strong> Monitors RFS and LCFS credit
      prices in real time. Recommendation: Hold Batch 402 and capture an
      additional 8% margin during the projected price surge.
    </li>
  </ol>

  <p>
    <strong>Why Time Savings Alone Undersell AI’s True ROI</strong>
    <br />
    Much of today’s AI ROI discussion focuses on time savings. These gains are
    real, but efficiency is only the starting point.
  </p>

  <p>
    Time saved does not automatically translate into strategic business impact.
    The true value of AI lies in helping companies make better decisions that
    drive superior economic outcomes.
  </p>

  <p>
    <strong>From Productivity Gains to Economic Advantage</strong>
  </p>

  <ul>
    <li>Surface hidden risks before they materialize</li>
    <li>Identify constraints that quietly erode performance</li>
    <li>Model trade-offs leaders might otherwise overlook</li>
    <li>Reveal second- and third-order effects of decisions</li>
  </ul>

  <p>
    In these cases, AI’s ROI is not measured in hours saved — but in losses
    avoided and opportunities captured.
  </p>

  <p>
    <strong>Economic Impact: From FID to Daily Ops</strong>
  </p>

  <table className="table table-bordered mt-3">
    <thead>
      <tr>
        <th>Decision Type</th>
        <th>Traditional Approach</th>
        <th>Agentic AI Approach</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Capital Planning / FID</td>
        <td>Static spreadsheets based on historical averages</td>
        <td>
          Stochastic simulations running thousands of scenarios to stress-test
          IRR
        </td>
      </tr>
      <tr>
        <td>Business Development</td>
        <td>Manual competitive analysis</td>
        <td>
          Competitive intelligence agents benchmarking technologies in real time
        </td>
      </tr>
      <tr>
        <td>Daily Operations</td>
        <td>Reactive adjustments from shift logs</td>
        <td>
          Continuous learning engines matching patterns and identifying fixes
          instantly
        </td>
      </tr>
    </tbody>
  </table>

  <p>
    <strong>Conclusion: The Goal Is Better Learning</strong>
    <br />
    Judgment and experience still matter. But when intuition is supported by an
    end-to-end view and a learning knowledge base, decisions become easier to
    explain, review, and improve.
  </p>

  <p>
    The goal is not perfect decisions — it is fewer surprises and better learning
    when they happen. This is where AI transitions from a cost-saving tool to a
    permanent competitive advantage.
  </p>
</>
  ),
      // linkedinLink:
      //   "https://www.linkedin.com/posts/sujathak-dsider_nyclimateweek-decarbonization-energytransition-activity-7244748108281044992-6iG9/?utm_source=share&utm_medium=member_ios",
    },
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_1.png",
      title:
        "With Climate Week activities in full swing and discussions on First of a Kind (FOAK) innovations ongoing, ",
      text: "it's crucial to focus on balancing emission reductions with economic sustainability for real climate impact. Dsider FOAK solution tackles the Techno-Economic Analysis challenge, streamlining the energy transition and decarbonization process. This empowers companies to shift confidently to low-carbon products, facilitating a more precise and sustainable transformation. Let's work together to make the energy transition smarter! 🌱📢 Calling all startups, project developers, industrial companies, and financial institutions — together, we can drive meaningful change.",
      linkedinLink:
        "https://www.linkedin.com/posts/sujathak-dsider_nyclimateweek-decarbonization-energytransition-activity-7244748108281044992-6iG9/?utm_source=share&utm_medium=member_ios",
    },
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_2.png",
      title:
        "We've been highlighting the vital role of Techno-Economic Analysis (TEA) in driving the energy transition and advancing decarbonization efforts.",
      text: "TEA is not merely a tool; it serves as a fundamental cornerstone for evaluating initiatives and new technologies. It ensures their feasibility, unlocks maximum economic returns, and effectively mitigates risks—ultimately guiding us toward achieving NetZero sustainably. How is your organization leveraging TEA to accelerate the energy transition? Contact us to learn more or get a demo at Info@dsider.app",
      linkedinLink:
        "https://www.linkedin.com/posts/sujathak-dsider_energytransition-decarbonization-technoeconomicanalysis-activity-7246889163487125504-ee8S/?utm_source=share&utm_medium=member_ios",
    },
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_3.png",
      title:
        "The path to a sustainable decarbonized future demands a new approach, and Dsider is here to lead the way.",
      text: "As companies across all industries navigate the energy transition, they’re facing a critical challenge: how can they be responsible, green enterprises while continuing to deliver value to stakeholders! Connect with us info@dsider.app to have a discussion.",
      linkedinLink:
        "https://www.linkedin.com/posts/sujathak-dsider_energytransition-decarbonization-sustainability-activity-7249788281259753472-W19l/?utm_source=share&utm_medium=member_ios",
    },
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_4.png",
      title:
        "Over the past few weeks, we’ve emphasized the value of techno-economic analysis (TEA) for startups, financial organization and industrial companies.",
      text: "In the last 18 months, many firms have scaled back their sustainability goals. BP and Shell adjusted targets due to rising oil prices, while Microsoft fell short on carbon reductions with the growth of AI. Key challenges include unrealistic targets, limited returns on decarbonization, and the need to quantify future carbon costs. It is possible to balance environmental benefits with returns! Success requires meaningful, actionable, and scalable efforts. Climate innovators, financial organizations, and industrial companies—let’s connect to strengthen your sustainability strategy and business model with actionable insights.",
      linkedinLink:
        "https://www.linkedin.com/posts/dsider_netzero-sustainability-tea-activity-7252424899376398339-MbOb/?utm_source=share&utm_medium=member_ios",
    },
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_5.png",
      title:
        "How this Houston energy tech startup transforms innovation into scalable success",
      text: "What if the future of clean energy wasn’t just about invention, but execution? For Sujatha Kumar, CEO of Dsider, success in clean tech hinges on more than groundbreaking technology—it’s about empowering founders with the tools to make their innovations viable, scalable, and economically sound. Through Dsider’s techno-economic analysis (TEA) platform, Kumar is helping startups bridge the critical gap between vision and execution, ensuring they can navigate complex markets with confidence.",
      linkedinLink:
        "https://www.linkedin.com/posts/dsider_dsider-houstoninnovation-greentown-activity-7240330659926306816-H48E?utm_source=share&utm_medium=member_ios",
    },
    {
      id: uuidv4(), // Generate a unique UUID
      image: "blogs/blog_6.png",
      title:
        "Meet the startups selected for #AWS generative AI for Energy Lab announced last week during the Energy Symposium in Houston!",
      text: "We're excited to announce that Dsider was selected for the AWS Generative AI Energy Lab out of 800+ applications from 74 countries ! 🌎 We look forward to connecting and collaborating with AWS enterprise customers to test and deploy our generative AI climate tech solutions.",
      linkedinLink:
        "https://www.linkedin.com/posts/aws-energy-utilities_aws-activity-7232062122073931776-OMlm?utm_source=share&utm_medium=member_desktop",
    },
  ];

  const handleReadMore = (blog) => {
    setSelectedBlog(blog);
    setShowModal(true);
  };

const limitText = (blog) => {
  const text = blog.preview || blog.text;

  if (typeof text === "string") {
    return text.length > 150
      ? text.substring(0, 70) + "..."
      : text;
  }

  return "";
};

  return (
    <div>
      <Header />
      <Container className="my-5">
        <div className="d-flex justify-content-center align-items-center mb-4">
          <h1 className="blog-heading mb-0">Our Blogs</h1>
          <img
            src={`${BASE_URL}common-images/mask_image.png
`}
            alt="Mask"
            className="mask-image"
          />
        </div>
        <Row xs={1} md={3} lg={3} className="g-3">
          {blogs.map((blog, index) => (
            <Col key={blog.id}>
              <Card
                className="h-100 blog-card mx-auto"
                style={{
                  margin: "0 auto",
                  border:
                    index === 0 ? "2px solid #478AB2" : "2px solid #E7E7E7", // Add border to the first card
                }}
              >
                {index === 0 && (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={`${BASE_URL}common-images/latest-card.png`}
                      alt="latestcard"
                      className="latest-image"
                    />
                    <div className="blog-latest-card">Latest</div>
                  </div>
                )}
                <Card.Img
                  variant="top"
                  src={`${BASE_URL}${blog.image}`} // Construct full URL
                  className="blog-image my-3"
                />
                <Card.Body className="d-flex flex-column card-body-custom text-start">
                  <Card.Title className="blogtitle">{blog.title}</Card.Title>
                  <Card.Text className="blogtext">
                    {" "}
                    {limitText(blog)} {/* Truncated text for NewsPage */}
                  </Card.Text>
                  <Button
                    className="mt-auto align-self-center z-btn-blog z-btn-3-blog"
                    onClick={() => handleReadMore(blog)} // Pass the full blog object
                  >
                    Read More
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <ContactForm showHeader={false} showFooter={false} />
      <NewFooter />

      {/* Modal for displaying blog details */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        keyboard={true}
        centered
        className="modelDsiderblog"
        style={{ background: "transparent" }}
      >
        <Modal.Header closeButton>
          {" "}
          {/* Add close button at the top right */}
        </Modal.Header>
        <Modal.Body
          style={{
            overflowY: "auto",
            maxHeight: "70vh",
            overflowX: "hidden",
            padding: "5px",
            paddingRight: "2rem",
          }}
          className="custom-scrollbar" // Add a custom class for scrollbar styling
        >
          {selectedBlog && (
  <Container fluid>
    {/* TOP ROW: Image + Intro */}
    <Row className="mb-4">
      <Col md={6}>
        <Image
          src={`${BASE_URL}${selectedBlog.image}`}
          alt="Blog"
          style={{
            width: "100%",
            height: "250px",
            objectFit: "cover",
            borderRadius: "20px",
          }}
        />
      </Col>

      <Col md={6}>
        <h3 className="singleBlogtitle">{selectedBlog.title}</h3>

        {selectedBlog.intro ? (
          <div className="singleBlogtext">
            {selectedBlog.intro}
          </div>
        ) : (
          <p className="singleBlogtext">{selectedBlog.text}</p>
        )}
      </Col>
    </Row>

    {/* FULL-WIDTH BODY */}
    {selectedBlog.body && (
      <Row>
        <Col md={12}>
          <div className="singleBlogtext">
            {selectedBlog.body}
          </div>
        </Col>
      </Row>
    )}

    {/* SOURCE */}
    <Row className="mt-3">
      <Col>
      {selectedBlog.linkedinLink && (
        <a
          href={selectedBlog.linkedinLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            Source:
            <span
              style={{
                color: "#0056C0",
                fontFamily: "Poppins",
                fontWeight: "300",
                fontSize: "14px",
                marginLeft: "4px",
              }}
            >
              {selectedBlog.linkedinLink}
            </span>
          </span>
        </a>
      )}
      </Col>
    </Row>
  </Container>
)}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BlogsPage;
